export const getModule = () => ('./module')

export const getStoryBlokSaga = () => import(/* webpackChunkName: "storyblokSaga" */'./sagas')


export { default as storyblokReducer } from './reducers'
export { watchStoryblok } from './sagas'
